/* Product revamp interactions: simple popups + subscription selector */
(function () {
  function openPopup(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closePopup(el) {
    el.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-popup-open]');
    if (trigger) {
      e.preventDefault();
      openPopup(trigger.getAttribute('data-popup-open'));
      return;
    }
    var closer = e.target.closest('[data-popup-close]');
    if (closer) {
      var pop = closer.closest('.simple-popup');
      if (pop) closePopup(pop);
      return;
    }
    var pop = e.target.classList && e.target.classList.contains('simple-popup') ? e.target : null;
    if (pop) closePopup(pop);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.simple-popup.is-open').forEach(closePopup);
  });

  function initSubscriptionSelector(root) {
    var options = root.querySelectorAll('.subscription-option');
    var hiddenInput = root.querySelector('[data-selling-plan-input]');
    function select(opt) {
      options.forEach(function (o) {
        o.classList.toggle('is-selected', o === opt);
        var r = o.querySelector('.subscription-option__radio');
        if (r) r.checked = o === opt;
      });
      var plan = opt.getAttribute('data-selling-plan-id') || '';
      var sel = opt.querySelector('.subscription-option__plan-select');
      if (sel && sel.value) plan = sel.value;
      if (hiddenInput) hiddenInput.value = plan;
    }
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        select(opt);
      });
      var sel = opt.querySelector('.subscription-option__plan-select');
      if (sel) {
        sel.addEventListener('change', function () {
          select(opt);
        });
        sel.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      }
    });
  }

  function portalPopupsToBody() {
    document.querySelectorAll('.simple-popup').forEach(function (p) {
      if (p.parentElement !== document.body) document.body.appendChild(p);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.subscription-selector').forEach(initSubscriptionSelector);
    portalPopupsToBody();
  });
})();
